export default {
      id: "cushion_mod-usage",
      viewBox: "0 0 25 30",
      url: __webpack_public_path__ + "icons.svg#cushion_mod",
      toString: function () {
        return this.url;
      }
    }